/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_Top_PathsInputs */

const en_admin_funnel_history_top_paths = /** @type {(inputs: Admin_Funnel_History_Top_PathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top pages (page views)`)
};

/**
* | output |
* | --- |
* | "Top pages (page views)" |
*
* @param {Admin_Funnel_History_Top_PathsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_top_paths = /** @type {((inputs?: Admin_Funnel_History_Top_PathsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_Top_PathsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_top_paths(inputs)
});
export { admin_funnel_history_top_paths as "admin.funnel.history.top_paths" }